import { createSlice } from '@reduxjs/toolkit';
import notificationOperations from './notifications-operations';

const initialState = {
  items: [],
  isLoading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(notificationOperations.getAllSettings.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(notificationOperations.getAllSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(notificationOperations.getAllSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(notificationOperations.createSetting.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(notificationOperations.updateSetting.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          item => item.code === action.payload.code
        );
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(notificationOperations.bulkUpdateSettings.fulfilled, (state, action) => {
        state.items = action.payload;
      });
  },
});

export default notificationsSlice.reducer;
